module.exports = {	
	'Connect Wallet' : '連接錢包',
	'Lossless mining' : '無損挖礦',
	'Liquidity pledge-free' : 'Liquidity pledge-free',
	'Reward' : '獎勵',
	'Million' : '一百萬',
	'Receive Voucher' : '領取優惠券',
	'Invite Friends' : '邀請好友',
	'Mining Pool' : '礦池',
	'Account' : '賬戶',

	'Pool data' : '池數據',
	'Valid node' : '有效節點',
	'Participant' : '參與者',
	'User Revenue' : '用戶收益',
	'Mining' : '挖礦',
	'Liquidity mining income' : 'Liquidity mining income',
	'User Output' : '用戶輸出',
	'Address' : '地址',
	'Help center' : '幫助中心',
	'Hope it helps you' : 'Hope it helps you',
	'How do i need to join？' : '我需要怎麼加入？',
	'Participating in non-destructive and non-guaranteed liquidity mining requires payment of ETH miner fees to receive the replacement gold coupons, and the ETH wallet address only needs to be claimed once. Automatically open mining permissions after success.' : '參與非破壞性和非保證流動性挖礦需要支付ETH礦工費才能領取替換金券，ETH錢包地址只需認領一次。成功後自動開啟挖礦權限。',
	'How do i withdraw money？' : '我如何取款？',
	'You can convert the currency generated every day into USDT, and then initiate a withdrawal. USDT withdrawals will be automatically sent to the wallet address you added to the node, other addresses are not supported.' : '您可以將每天產生的貨幣兌換成USDT，然後發起提現。 USDT提現會自動發送到您添加到節點的錢包地址，不支持其他地址。',
    'How to calculate income？':'如何計算收入？',
    'When you join successfully, the smart contract starts to calculate your address through the node and start to calculate the revenue.' : '當你加入成功後，智能合約開始通過節點計算你的地址，並開始計算收益。',
    'What is revenue？':'什麼是收益率？',
    'The yield below1000USDT≈0.5%~0.6%, ' : '1000USDT以下收益率≈0.5%~0.6%，',
    '1000USDT-5000USDT≈1.6%~2.0%, ' : '1000USDT-5000USDT≈1.6%~2.0%，',
    '5000USDT-20000USDT yield≈1.8%~2.2%, ' : '5000USDT-20000USDT收益率≈1.8%~2.2%， ',
    '20000USDT-50000USDT yield≈2.2%~2.6%, ' : '20000USDT-50000USDT收益率≈2.2%~2.6%，',
    '50000USDT-200000USDT yield≈2.6%~3.0%, ' : '50000USDT-200000USDT收益率≈2.6%~3%，',
    'and above 200000USDT yield Rate≈2.8%~3.5% ' : '200000USDT以上收益率≈2.8%~3.5%',
    'What are the extra gains？' : '額外的收穫是什麼？',
    'Please keep an eye on website promotions for more additional benefits.' : '您可以將我們的頁面分享給朋友，如果他加入，您可以獲得他收入的10%作為獎金，您的分享鏈接在首頁左上角獲得。',
	'My account' : '我的帳戶',
	'Total output' : '總產量',
	'Wallet balance' : '錢包餘額',
	'Exchangeable' : '可兑换',
	'Withdrawable' : '可提取',
	'Exchange' : '兑换',
	'Withdraw' : '提取',
	'Record' : '記錄',
	'Redeem all' : '全部兌換',
	'Total balance' : '總餘額',
	'Confirm' : 'Confirm',
	'Time' : '時間',
	'Quantity' : '數量',
	'Status' : '狀態',
	'No Data' : '無數據',
	'Output' : '輸出',
	'Fee' : '費用',
	'Scope' : '範圍',
	'Daily acceptance times' : '每日受理次數：',
	'Your withdrawal will be sent to your USDT wallet address within 24 hours in the future' : '您的提款將在未來 24 小時內發送到您的 USDT 錢包地址',
	'Audit report' : '審計報告',
	'We have a secure audit report' : '我們有一份安全的審計報告',
	'Partner' : '合作夥伴',
	'our business partner' : '我們的商業夥伴',
	'Share friends' : '分享朋友',
	'My share link' : '我的分享鏈接',
	'Copy' : '複製',
	"Send your invitation link, friends join the node through your link, and you will get generous token rewards.You can get 10% of the recommended person's income" : "發送您的邀請鏈接，好友通過您的鏈接加入節點，您將獲得豐厚的代幣獎勵。您可以獲得推薦人收入的10%",
	'There was an issue signing you in.' : '登錄時出現問題。',
	'Receive description' : '接收說明',
	"You need to pay a miner's fee to receive the voucher, please make sure that your wallet has enough ETH as the miner's fee" : "您需要支付礦工費才能領取代金券，請確保您的錢包有足夠的ETH/TRX作為礦工費",
	"Receive" : "接收",
	"You have successfully joined the node and started mining" : "你已經成功加入節點，已開始挖礦",
}


// WEBPACK FOOTER //
// ./src/assets/lang/cn.js